import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Card, Col, Container, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import Breadcrumb from '../../components/Common/Breadcrumb';
import { AddSamplesToTestsTab } from '../../features/LabCitec/Requests/Information/Tests/AddSamplesToTestsTab';
import { TestGenerationTab } from '../../features/LabCitec/Requests/Information/Tests/TestGenerationTab';
import { SpecialRequirements } from "../../features/LabRequests/SpecialRequirements/SpecialRequirements";
import { getLabRequestTests } from '../../store/actions';
import { BackButton } from './BackButton';

export const AddInfoToTest = (props) => {

    // TODO: Hay otra forma en la que se esta recuperando del local storage, esta en la vista de lab citec details
    const labType = localStorage?.getItem("lType") ? JSON.parse(localStorage?.getItem("lType") ?? `{"labType": '1' }`) : '0'

    const [activeTest, setActiveTest] = useState();

    const [activeTab, setActiveTab] = useState('1');

    const profiletoggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    // * Redux
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getLabRequestTests(`?limit=500&page=0&labRequest=${props?.match?.params?.id}`));
    }, [dispatch, props?.match?.params?.id])



    const { labRequestTests } = useSelector(state => ({
        labRequestTests: state.labRequestTestReducer.labRequestTests,
    }), shallowEqual);

    useEffect(() => {
        setActiveTest(
            labRequestTests.filter(item => item.id === props?.match?.params?.rowInfoLabTestViewId)
        );
    }, [labRequestTests, props?.match?.params?.rowInfoLabTestViewId])

    return (

        <div className="page-content">
            <Container fluid className="" >
                <Col className="col-12" style={{ padding: 40 }}>
                    <Card className='' style={{ padding: 20 }}>

                        {
                            labType === 'CITEC' ?
                                <Breadcrumb breadcrumbItem1='labCitec' breadcrumbItem2='addInfoToTest' /> : <Breadcrumb breadcrumbItem1='labMoviles' breadcrumbItem2='addInfoToTest' />
                        }

                        <Card className='' style={{ padding: 20 }}>

                            <div className='d-flex align-items-center justify-content-between'>

                                {
                                    (activeTest)
                                        ? <h4 className='text-success'>ENSAYOS DE LABORATORIO | SOLICITUD DEL SERVICIO {activeTest[0]?.code}</h4>
                                        : null
                                }

                                <BackButton props={props} />
                            </div>

                            <hr className='text-primary mt-0' />

                            <Card className='' style={{ padding: 20 }}>

                                <h4><u className='text-primary'>Información del ensayo</u></h4>

                                <div className='d-flex align-items-center justify-content-between mt-3 mb-5 w-75'>

                                    {
                                        (activeTest)
                                            ?
                                            <>
                                                <h5 className='text-secondary' ><strong>Ensayos: </strong>{activeTest[0]?.labTest.name}</h5>
                                                <h5 className='text-secondary' ><strong>Norma: </strong>{activeTest[0]?.labTest.norm.name}</h5>
                                                <h5 className='text-secondary' ><strong>Método: </strong>{activeTest[0]?.labTest.method}</h5>
                                            </>
                                            : null
                                    }

                                </div>

                            </Card>

                            <Nav tabs className="nav-tabs-custom nav-justified">

                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({ active: activeTab === '1' })}
                                        onClick={() => { profiletoggle('1'); }}
                                    >
                                        <h5 className='m-0'>Asignación de muestras a ensayo</h5>
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({ active: activeTab === '2' })}
                                        onClick={() => { profiletoggle('2'); }}
                                    >
                                        <h5 className='m-0'>Requerimientos especiales u observaciones</h5>
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        disabled={false}
                                        style={{ cursor: "pointer" }}
                                        className={classnames({ active: activeTab === '3' })}
                                        onClick={() => { profiletoggle('3'); }}
                                    >
                                        <h5 className='m-0'>Generación de ensayos</h5>
                                    </NavLink>
                                </NavItem>

                            </Nav>

                            <TabContent activeTab={activeTab} className="p-4 pb-0">

                                <TabPane tabId="1">
                                    <AddSamplesToTestsTab props={props} />
                                </TabPane>

                                <TabPane tabId="2">
                                    <SpecialRequirements props={props} activeTab={activeTab} />
                                </TabPane>

                                <TabPane tabId="3">
                                    <TestGenerationTab props={props} />
                                </TabPane>

                            </TabContent>

                        </Card>

                        <br />
                        <br />

                    </Card>
                </Col>
                <ToastContainer autoClose={2000} newestOnTop={true} />
            </Container>
        </div>

    )
}

